import { localeMap, LocaleType } from 'constants/locale_map';

export const getLocaleFromI18nLanguage = (language: string): LocaleType => {
  return localeMap[language as keyof typeof localeMap] || 'enUS';
};
